import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PersonalInformationForm from '../../components/PersonalInformationForm';
import OuterLayer from '../../containers/OuterLayer';
import { useLabels } from '../../hooks';
import { PageContext, UserContext, UserType, OutersContainerContext } from '../../contexts';
import styles from './PersonalInformation.module.scss';

const pageKey = "personal_information";

const PersonalInformation = () => {
  const { getLabel, getLocalUrlByLanguage } = useLabels();
  const { setPageKey } = useContext(PageContext);
  const { userType } = useContext(UserContext);
  const { appLayoutTitleContainer } = useContext(OutersContainerContext);
  const navigate = useNavigate();

  useEffect(() => {
    if(userType !== UserType.privet && userType !== UserType.external) {
      navigate(getLocalUrlByLanguage(`/user`));
    }
  }, [getLocalUrlByLanguage, navigate, userType]);

  useEffect(() => {
    setPageKey(pageKey);
  }, [setPageKey]);

  
  return <>
    <OuterLayer container={appLayoutTitleContainer} TagWrapper='span'>{getLabel("personalinformation_page_title")}</OuterLayer>
    <div className={styles.container}>
      <PersonalInformationForm />
    </div>
  </>;
};

export default PersonalInformation;
